import { AxiosProgressEvent } from "axios";
import apiClient from "services/httpClient/userClient";
import { AccountNumberConfirmResponse } from "./models";
import { uploadCorporateDocument } from "./document";

export type uploadKey = {
  progress?: string | number;
  success?: boolean;
  error?: boolean;
};
export const addCorporateDirector = (payload: any) =>
  apiClient.post("/api/CorporateDirector", payload);

export const updateCorporateDirector = (payload: any) =>
  apiClient.put("/api/CorporateDirector", payload);

export const getCorporateDirector = () =>
  apiClient.get("/api/CorporateDirector");

export const deleteCorporateDirector = (directorId: string) =>
  apiClient.delete(`/api/CorporateDirector/${directorId}`);


//  End of Corporate Director

export const addCorporateDocument = (
  payload: any,
  func: (val: uploadKey) => void
) => {
  const config = {
    onUploadProgress: function (progressEvent: AxiosProgressEvent) {
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / (progressEvent.total ?? 100)
      );
      func({ progress: percentCompleted });
    },
  };
  uploadCorporateDocument(payload, config)
    .then((data) => {
      func({ success: true });
    })
    .catch((err) => {
      func({ error: true });
    });
};

// export const getCorporateDocumentTypes = () =>
//   apiClient.get("/api/Document/get-corporate-document-types");

export const getCorporateDocument = (documentId: string) =>
  apiClient.get(`/api/Document/get-corporate-document/${documentId}`);

export const deleteCorporateDocument = (documentId: string) =>
  apiClient.delete(
    `/api/Document/delete-corporate-document/${documentId}`
  );
// End of Corporate Document

export const addBankAccount = (payload: any) =>
  apiClient.post("/api/BankAccount", payload);

export const updateBankAccount = (payload: any) =>
  apiClient.put("/api/BankAccount", payload);

export const getBankAccount = () => apiClient.get("/api/BankAccount");
export const getBanks = () => apiClient.get("/api/BankAccount/banks");

export const deleteBankAccount = (accountId: string) =>
  apiClient.delete(`/api/BankAccount/${accountId}`);

export const getAccountNameEnquiry = (payload: {
  account_no: string;
  bank_code: string;
}) => apiClient.post<AccountNumberConfirmResponse>("/api/BankAccount/account-name-enquiry", payload)
.catch((err) => {
  return 'Unable to confirm account.'
});
